export default class ClienteEndereco {

  constructor(
    IdCliente = null,
    IdItem = null,
    IdTipoEndereco,
    TipoEndereco,
    Endereco,
    Numero,
    Complemento,
    PontoReferencia,
    IdBairro,
    Bairro,
    IdCidade,
    Cidade,
    Cep,
    Titulo = 'RESIDENCIAL'
  ) {
    this.IdCliente = IdCliente;
    this.IdItem = IdItem;
    this.IdTipoEndereco = IdTipoEndereco;
    this.TipoEndereco = TipoEndereco;
    this.Endereco = Endereco;
    this.Numero = Numero;
    this.Complemento = Complemento;
    this.PontoReferencia = PontoReferencia;
    this.IdBairro = IdBairro;
    this.Bairro = Bairro;
    this.IdCidade = IdCidade;
    this.Cidade = Cidade;
    this.Cep = Cep;
    this.Titulo = Titulo;
  }
  
}